<div class="home-page h-100">
  <div class="d-flex justify-content-end" style="padding: 10px; height: 50px;">
    <!-- ngôn ngữ -->
    <a *ngIf="currentLang === 'vi'" style="margin-top: 2px; margin-right: 0.5rem;" nz-dropdown nzTrigger="click" [nzDropdownMenu]="language"
      [nzPlacement]="'bottomRight'">
      <img style="width: 1.375rem; height: 1.375rem; border-radius: 48px; border: solid 1px #fff;"
        src="./../../../assets/images/language-vietnamese.png" alt="">
    </a>
    <a *ngIf="currentLang === 'en'" style="margin-top: 2px; margin-right: 0.5rem;" nz-dropdown nzTrigger="click" [nzDropdownMenu]="language"
      [nzPlacement]="'bottomRight'">
      <img style="width: 1.375rem; height: 1.375rem; border-radius: 48px; border: solid 1px #fff;"
        src="./../../../assets/images/language-english.png" alt="">
    </a>
    <nz-dropdown-menu #language="nzDropdownMenu">
      <ul style="padding: 0.5rem !important;" nz-menu nzMode="horizontal" class="language" [nzInlineCollapsed]="true">
        <li style="padding: 0.5rem 0.75rem !important;" nz-menu-item *ngFor="let item of listLang; trackBy: trackByFn"
          (click)="onSelectLange(item.id)" [nzSelected]="item.id == currentLang">
          <img style="width: 1.75rem; height: 1.25rem; border-radius: 0.125rem; margin-right: 1rem;" [src]="item.icon"
            alt="">{{ item.value | translate}}
        </li>
      </ul>
    </nz-dropdown-menu>

    <button nz-button nzType="primary" (click)="logout()" nzGhost type="button" class="btn-logout">
      <span>{{ 'HOME.LOGOUT' | translate}}</span>
    </button>
  </div>
  <div class="home-logo d-flex justify-content-center align-items-center">
    <!-- <img [src]="'assets/images/logo.svg'" alt=""> -->
    <div class="d-flex flex-column align-items-center justify-content-end">
      <!-- <span class="title">viettel</span>
      <span class="sub-title d-flex justify-content-end w-100">sports</span> -->
      <i nz-icon nzType="icons:viettel-sports" class="fs-logo mb-2" nzTheme="outline" aria-hidden="true"></i>
    </div>
  </div>
  <div class="menu-wrapper d-flex align-items-center justify-content-center">
    <div class="menu d-flex flex-wrap justify-content-center">
      <div class="cover-func cursor-pointer" *ngFor="let item of menus" (click)="goTo(item)">
        <i nz-icon [nzType]="item.icon" class="fs-28 mb-2" nzTheme="outline" aria-hidden="true"></i>
        <span class="title">{{item.titleKey | translate}}</span>
      </div>
    </div>
  </div>

</div>
